export class Vertical 
{
    public VerticalId : Number;
    public VerticalCode : string;
    public VerticalName : string;
    public CompId : Number;
    public IsActive : boolean;
    public branches : string;
}